import { render, staticRenderFns } from "./NewClassicEnrollment.vue?vue&type=template&id=33a087da&"
import script from "./NewClassicEnrollment.vue?vue&type=script&lang=js&"
export * from "./NewClassicEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports